import { ThemeUICSSObject } from '@apia/theme';
import { form } from './form';
import { history } from './history';
import { controller } from './controller';
import { attachments } from './attachments';
import { message } from './message';
import { assistant } from './assistant';
/* IMPORT HERE */
export const newChat: ThemeUICSSObject = {
  /* PREPEND HERE */
  assistant,
  form,
  history,
  controller,
  attachments,
  message,
};
